
export const paymentMethods = {
    Cash: 'Cash',
    Card: 'Card',
    Qr: 'Qr',
    Posnet: 'Posnet',
    Link: 'Link',
    Check: 'Check',
    Transfer: 'Transfer',
    GOcuotas: 'GOcuotas',
    TerminalQr: 'TerminalQr'
}

export const displayMethods = {
    Cash: 'Efectivo',
    Card: 'Tarjeta credito/debito',
    Qr: 'Mercado Pago QR',
    Posnet: 'Posnet',
    Link: 'Mercado Pago Link',
    Check: 'Cheque',
    Transfer: 'Transferencia',
    GOcuotas: 'GO Cuotas',
    TerminalQr: 'Terminal QR'
}

export const cardTypes = {
    Credit: 'Crédito',
    Debit: 'Débito'
}

export const columns = [
    {
        field: 'cashTypeTranslated',
        header: 'Medio de pago'
    },
    {
        field: 'ingressTotal',
        header: 'Ingresos',
        type: 'money'
    },
    {
        field: 'egressTotal',
        header: 'Egresos',
        type: 'money'
    },
    {
        field: 'total',
        header: 'Total',
        type: 'money',
    },
    {
        field: 'cantTickets',
        header: 'Tickets'
    }
];